export default "__VITE_ASSET__Cvx6kDfJ__"